module.exports = __webpack_public_path__ + "img/nothear.297d1eb6.svg";